export default function ContactMe() {
  return (
    <section id="Contact" class="contact--section">
      <div>
      <h2 className="skills--section--heading">Contact Me</h2>
   
        <br></br>
        <br></br>
        <br></br>

        <div class="contact-buttons">
          <a href="https://www.linkedin.com/in/guillermo-kramsky-iturbide-5a9ba3246" class="btn btn-primary">
            LinkedIn
          </a>
          <a href="mailto:memo.kramsky@gmail.com" class="btn btn-primary">
            Write Email
          </a>
        </div>
      </div>
    </section>


  );
}
